
      import API from "!../../examples/react-example/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../examples/react-example/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../examples/react-example/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../examples/react-example/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../examples/react-example/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../examples/react-example/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../examples/react-example/node_modules/css-loader/dist/cjs.js!./main.css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../examples/react-example/node_modules/css-loader/dist/cjs.js!./main.css";
       export default content && content.locals ? content.locals : undefined;
